// extracted by mini-css-extract-plugin
module.exports = {"main":"Scaffold_main__VzYrY","scaffold":"Scaffold_scaffold__T0ENi","mainContent":"Scaffold_mainContent__lrjz2"};